import React from 'react';
import PageNotFound from '@framework/ui/Pages/PageNotFound';
import { getPageTitle } from '@/creditflowresearch/ui/common/helpers';

const PageNotFoundWrp = () => (
  <PageNotFound title={ getPageTitle('Page not found') } />
);

export default PageNotFoundWrp;
